enum FeuilleSaisieCode {
	DOTATIONS_AUX_AMORTISSEMENT = 'DOTA',
	INVESTISSEMENT_PAR_CHAPITRE = 'INVC',
	INVESTISSEMENT_PAR_OPERATION = 'INVO',
	FONCTIONNEMENT = 'FONC',
	OPERATION_ORDRE_BUDGETAIRE = 'OPERO',
}

export default FeuilleSaisieCode;
